import { useAuthStore } from "../state/auth";

export interface DashboardSummary {
    hospital_id: string;
    hospital_name?: string;
    metrics: {
        total_scans_today: number;
        location_count: number;
        /** All registered checkpoints, including switched-off ones. */
        total_location_count?: number;
    };
    recent_uploads: any[];
    locations: any[];
}

export async function fetchDashboardSummary(hospitalId?: string): Promise<DashboardSummary> {
    const { user, token } = useAuthStore.getState();
    if (!user?.email) throw new Error("User not authenticated");

    const url = new URL("/api/dashboard/summary", window.location.origin);
    if (hospitalId) {
        url.searchParams.append("hospital_id", hospitalId);
    }

    const headers: Record<string, string> = {
        "x-user-email": user.email,
    };
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(url.toString(), { headers });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "Failed to fetch dashboard summary");
    }

    return response.json();
}
